export const CEILING_MATERIAL_OPTIONS = [
    { label: "Metal", value: "metal" },
    { label: "PVC", value: "pvc" },
    { label: "Aluminium Strip", value: "aluminiumStrip" },
];

export const IPOH_CEILING_MATERIAL_OPTIONS = [
    { label: "Metal", value: "metal" },
    { label: "Timberflex", value: "timberflex" },
    { label: "Aluminium Strip", value: "aluminiumStrip" },
];

export const CEILING_COLOR_OPTIONS = [
    "Light Woodgrain",
    "Golden Woodgrain",
    "Natural Woodgrain",
    "Dark Woodgrain",
].map((color) => ({ label: color, value: color }));

const toColorOptions = (colors) => colors.map((color) => ({ label: color, value: color }));

const IPOH_BAMBOO_CEILING_COLORS = [
    "M1 (Brown)",
    "M2 (Light Brown)",
    "M3 (Red Brown)",
    "M4 (Dark Brown)",
    "M5 (White)",
    "M6 (Dark Grey)",
];

const IPOH_METAL_ALUMINIUM_CEILING_COLORS = ["Lavarock", "Cloudy Day", "Cotton Mallow"];

const IPOH_TIMBERFLEX_CEILING_COLORS = [
    "08 - Sandalwood",
    "07 - Golden Oak",
    "05 - Walnut",
    "23 - Rosewood",
    "14 - Light Oak",
    "24 - Graphite Grey",
];

export const IPOH_CEILING_COLORS_BY_CODE = {
    CB: IPOH_BAMBOO_CEILING_COLORS,
    CS: IPOH_METAL_ALUMINIUM_CEILING_COLORS,
    CA: IPOH_METAL_ALUMINIUM_CEILING_COLORS,
    CF: [],
    CT: IPOH_TIMBERFLEX_CEILING_COLORS,
};

export const IPOH_CEILING_COLOR_OPTIONS = toColorOptions([
    ...IPOH_BAMBOO_CEILING_COLORS,
    ...IPOH_METAL_ALUMINIUM_CEILING_COLORS,
    ...IPOH_TIMBERFLEX_CEILING_COLORS,
]);

export const getIpohCeilingColorOptions = (ceilingCode) => {
    if (!ceilingCode || !Object.prototype.hasOwnProperty.call(IPOH_CEILING_COLORS_BY_CODE, ceilingCode)) {
        return IPOH_CEILING_COLOR_OPTIONS;
    }
    return toColorOptions(IPOH_CEILING_COLORS_BY_CODE[ceilingCode]);
};

export const ACP_COLOR_OPTIONS = [
    "Metallic Silver & White",
    "Metallic Grey & White",
    "Metallic Grey & Metallic Silver",
    "Bronze & White",
    "Bronze & Silver",
    "Metallic Black & Silver",
    "Reddish Brown & White",
    "Yellow Shell Wood & Metallic Silver",
    "Yellow Bamboo & Metallic Silver",
    "Yellow Shell Wood & Metallic Grey",
].map((color) => ({ label: color, value: color }));

export const IPOH_ACP_COLOR_OPTIONS = [
    "Black Silver/Flash Silver",
    "Flash Silver/White",
    "Black Silver White",
    "Metallic Brown/White",
    "Royal / Metallic Grey",
].map((color) => ({ label: color, value: color }));

export const SIDE_HOARDING_OPTIONS = [
    { label: "Aluminium Louvers", value: "aluminium" },
    { label: "ACP", value: "acp" },
    { label: "Polycarbonate", value: "polycarbonate" },
    { label: "Metal Deck", value: "metal" },
];

export const REPLACEMENT_PANEL_OPTIONS = [
    { label: "ACP", value: "acp" },
    { label: "Polycarbonate", value: "polycarbonate" },
    { label: "PU Metal", value: "metal" },
];

export const CEILING_MATERIAL_LABELS = Object.fromEntries(
    [...CEILING_MATERIAL_OPTIONS, ...IPOH_CEILING_MATERIAL_OPTIONS].map(({ label, value }) => [value, label]),
);

export const SIDE_HOARDING_LABELS = Object.fromEntries(
    SIDE_HOARDING_OPTIONS.map(({ label, value }) => [value, label]),
);

export const REPLACEMENT_PANEL_LABELS = Object.fromEntries(
    REPLACEMENT_PANEL_OPTIONS.map(({ label, value }) => [value, label]),
);

export const formatAwningSupplementaryValue = (field, value) => {
    if (value === undefined || value === null || value === "") return value;
    if (field === "ceilingMaterial") {
        return CEILING_MATERIAL_LABELS[value] || value;
    }
    if (field === "sideHoarding") {
        return SIDE_HOARDING_LABELS[value] || value;
    }
    if (field === "replacementPanel") {
        return REPLACEMENT_PANEL_LABELS[value] || value;
    }
    return value;
};

export const AWNING_SUPPLEMENTARY_EMPTY_FIELDS = {
    ceilingMaterial: "",
    ceilingColor: "",
    acpColor: "",
    ceilingPrice: "",
    sideHoarding: "",
    sideHoardingPrice: "",
    replacementPanel: "",
    replacementPanelPrice: "",
};
